var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview-card"},[_c('div',{staticClass:"overview-card__header"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"font-base"},[_vm._v(_vm._s(_vm.title))]),_vm._t("subtitle")],2),_vm._t("action")],2),_c('div',{staticClass:"overview-card__content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }